import { useSearchParams } from "react-router-dom";

export const useUrlSearch = () => {
  const [search, setSearch] = useSearchParams();

  const gotoPage = (pageNumber) => {
    search.set("page", pageNumber);
    setSearch(search, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    if (!storeId) search.delete("store_id");
    else search.set("store_id", storeId);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterBySearch = (value) => {
    if (value?.length === 0) search.delete("query");
    else search.set("query", value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterByKey = (key, value) => {
    if (value?.length === 0 || !value) search.delete(key);
    else search.set(key, value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterByDate = (data) => {
    search.set("start_date", data?.startDate);
    search.set("end_date", data?.endDate);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  return {
    search,
    setSearch,
    gotoPage,
    filterByStoreId,
    filterBySearch,
    filterByKey,
    filterByDate,
  };
};
